import type { WatchHandle } from 'vue'

// Only run on client side
const longterm = reactive(
  typeof window !== 'undefined'
    ? useStorageDecoder(
        globalThis.localStorage?.getItem('outspot-longterm') ?? '',
      )
    : {},
)

// Only set up watcher on client side
let watchHandle: WatchHandle | null = null

if (typeof window !== 'undefined') {
  watchHandle = watch(
    longterm,
    () =>
      globalThis.localStorage?.setItem(
        'outspot-longterm',
        useStorageEncoder(longterm),
      ),
    {
      deep: true,
    },
  )
}

export function clearLongtermStorage(forceReload: boolean = false): void {
  if (typeof window !== 'undefined') {
    const keysToKeep = [
      'analyticalCookiesAccepted',
      'cookieBannerClosed',
      'lcc',
      'personalCookiesAccepted',
      'popupWidgetShown',
      'countrySelectorPopupHandled',
      'version',
    ]

    const valuesToKeep: any = {}

    keysToKeep.forEach((key) => {
      if (longterm[key]) {
        valuesToKeep[key] = longterm[key]
      }
    })

    globalThis.localStorage?.setItem(
      'outspot-longterm',
      useStorageEncoder(valuesToKeep),
    )

    if (forceReload) {
      watchHandle?.stop()
      globalThis.location.reload()
    }
  }
}

export default () => longterm
